// extracted by mini-css-extract-plugin
export default {"container":"InvoiceConfirmLoading_container__zz-Cv"};